import { FeatureFlag } from '../__generated__/fed-graphql-types'

export const useFeatureFlags = () => {
    const featureFlags: FeatureFlag[] = []
    return featureFlags
}
